import React from "react";
import GradientText from "@/components/GradiantTitle";

const TitleComponent = ({ text, description, size = "md" }) => {
  return (
    <GradientText className="flex !text-base flex-col gap-1 rtl:text-right">
      {text && (
        <p className={`font-semibold text-${size}`}>{text}</p>
      )}
      {description && <p className="text-sm text-gray-500">{description}</p>}{" "}
    </GradientText>
  );
};

export default TitleComponent;
